<div class="dialog-content-max"   *ngIf="isEdit">
    <form [formGroup]="myForm">
  
      <div class="formgrid grid">


        <div class="field col-4 ">
          <label for="releaseddate" class="required-label">Release Date </label>
          <p-calendar styleClass="pcalendar"[readonlyInput]=true formControlName="releaseddate" inputId="releaseddate" appendTo="body" [showIcon]="true" dateFormat="dd-M-yy"
          placeholder="Choose Released Date"name="releaseddate"  [maxDate]="maxDate" [showButtonBar]="true"[selectOtherMonths]="true" ></p-calendar>
        </div>
         
        <div class="field col-4">
            <div class="form-group">
                <label for="version" class="required-label"><b>Version</b> <span> *</span></label>
                <p-dropdown [options]="versionList"  inputId="version" formControlName="version"
                  placeholder="Select Version"
                   optionLabel="versionname" optionValue="rid" [showClear]="true" appendTo="body" name="version" ></p-dropdown>
                <span class="errormessage"
                  *ngIf="myForm.get('version').invalid && myForm.get('version').touched ">
                  {{getErrorMessage(myForm,validation_message,'version')}}
                </span>
            </div>
        </div>

        <div class="field col-4">
            <div class="form-group">
                <label for="category" class="required-label"><b>Category</b> <span> *</span></label>
                <p-dropdown [options]="categoryList"  inputId="category" formControlName="category"
                  placeholder="Select Category"
                   optionLabel="categoryname" optionValue="id" [showClear]="true" appendTo="body" name="category" ></p-dropdown>
                <span class="errormessage"
                  *ngIf="myForm.get('category').invalid && myForm.get('category').touched ">
                  {{getErrorMessage(myForm,validation_message,'category')}}
                </span>
            </div>
        </div>
        </div>


        <div class="formgrid grid">
            <div class="field col-4 ">
          <div class="form-group">
            <label for="product" class="required-label"><b>Product</b> <span> *</span></label>
          <p-dropdown [options]="productList"  inputId="product" formControlName="product"
            placeholder="Select Product"
             optionLabel="productinitial" optionValue="productid" [showClear]="true" appendTo="body" name="product" ></p-dropdown>
          <span class="errormessage"
            *ngIf="myForm.get('product').invalid && myForm.get('product').touched ">
            {{getErrorMessage(myForm,validation_message,'product')}}
          </span>
        </div>
        </div>

        <div class="field col-4">
            <div class="form-group">
            <label for="requirementid" class="required-label"><b>SDLC ID</b><span>&nbsp;*</span></label>
            <input class="form-control" type="number" placeholder="Enter SDLC ID"
              id="requirementid" formControlName="requirementid"  name="requirementid"/>
              <span class="errormessage"
              *ngIf="myForm.get('requirementid').invalid && myForm.get('requirementid').touched ">
              {{getErrorMessage(myForm,validation_message,'requirementid')}}
            </span>
            </div>
        </div>
        </div>
  

        <div class="formgrid grid">
            <div class="field col-12">
              <div class="form-group">
                <label for="feature" class="required-label"><b>Function Feature</b> <span> *</span>
                  <span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 500 chars)</span></label>
                <textarea class="form-control" type="text" placeholder="Enter Feature Name" pInputTextarea [autoResize]="true" 
                id="feature" formControlName="feature"  name="feature" rows="2"></textarea>
              <span class="errormessage"
                *ngIf="myForm.get('feature').invalid && myForm.get('feature').touched ">
                {{getErrorMessage(myForm ,validation_message,'feature')}}
              </span>
            </div>
          </div>
          </div>
    
          <div class="formgrid grid">
            <div class="field col-12">
              <div class="form-group">
                <label for="towhom" class="required-label"><b>To Whom</b> <span> *</span>
                  <span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 100 chars)</span></label>
                  <input class="form-control" type="test" placeholder="Enter To Whom"
                  id="towhom" formControlName="towhom"  name="towhom"/>
              <span class="errormessage"
                *ngIf="myForm.get('towhom').invalid && myForm.get('towhom').touched ">
                {{getErrorMessage(myForm ,validation_message,'towhom')}}
              </span>
            </div>
          </div>
          </div>
    
          <div class="formgrid grid">
            <div class="field col-12">
              <div class="form-group">
                <label for="advantages" class="required-label"><b>Advantages</b> <span> *</span>
                  <span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 1500 chars)</span></label>
                <textarea class="form-control" type="text" placeholder="Enter the Advantages" pInputTextarea [autoResize]="true" 
                id="advantages" formControlName="advantages"  name="advantages" rows="2"></textarea>
              <span class="errormessage"
                *ngIf="myForm.get('advantages').invalid && myForm.get('advantages').touched ">
                {{getErrorMessage(myForm ,validation_message,'advantages')}}
              </span>
            </div>
          </div>
          </div>
    
          <div class="formgrid grid">
            <div class="field col-12">
              <div class="form-group">
                <label for="functionality" class="required-label"><b>Functionality Description</b> <span> *</span>
                  <span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 5000 chars)</span></label>
                <textarea class="form-control" type="text" placeholder="Enter the Functionality Description"
                pInputTextarea [autoResize]="true" 
                id="functionality" formControlName="functionality"  name="functionality" rows="2"></textarea>
              <span class="errormessage"
                *ngIf="myForm.get('functionality').invalid && myForm.get('functionality').touched ">
                {{getErrorMessage(myForm ,validation_message,'functionality')}}
              </span>
            </div>
          </div>
          </div>
  
    </form>
  
    <div class="custom-dialog-footer">
      <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button>
      <p-button class="m-1" *ngIf="isEdit" label="{{saveTitle}}" styleClass="customesave" (click)="modify()"></p-button>
    </div>
  
  </div>
  

  <div class="dialog-content-max"   *ngIf="isAdd">
    <form [formGroup]="addForm">
  
      <div class="formgrid grid">
        <div class="field col-4">
            <div class="form-group">
                <label for="aversion" class="required-label"><b>Version</b> <span> *</span></label>
                <p-dropdown [options]="versionList"  inputId="aversion" formControlName="aversion"
                  placeholder="Select Version"
                   optionLabel="versionname" optionValue="rid" [showClear]="true" appendTo="body" name="aversion" ></p-dropdown>
                <span class="errormessage"
                  *ngIf="addForm.get('aversion').invalid && addForm.get('aversion').touched ">
                  {{getErrorMessage(addForm,validation_message,'aversion')}}
                </span>
            </div>
        </div>

        <div class="field col-4">
            <div class="form-group">
                <label for="acategory" class="required-label"><b>Category</b> <span> *</span></label>
                <p-dropdown [options]="categoryList"  inputId="acategory" formControlName="acategory"
                  placeholder="Select Category"
                   optionLabel="categoryname" optionValue="id" [showClear]="true" appendTo="body" name="acategory" ></p-dropdown>
                <span class="errormessage"
                  *ngIf="addForm.get('acategory').invalid && addForm.get('acategory').touched ">
                  {{getErrorMessage(addForm,validation_message,'acategory')}}
                </span>
            </div>
        </div>

        <div class="field col-4 ">
          <div class="form-group">
            <label for="aproduct" class="required-label"><b>Product</b> <span> *</span></label>
          <p-dropdown [options]="productList"  inputId="aproduct" formControlName="aproduct"
            placeholder="Select Product"
             optionLabel="productinitial" optionValue="productid" [showClear]="true" appendTo="body" name="aproduct" ></p-dropdown>
          <span class="errormessage"
            *ngIf="addForm.get('aproduct').invalid && addForm.get('aproduct').touched ">
            {{getErrorMessage(addForm,validation_message,'aproduct')}}
          </span>
        </div>
        </div>

      </div>


        <div class="formgrid grid">

        <div class="field col-4">
            <div class="form-group">
            <label for="arequirementid" class="required-label"><b>SDLC ID</b><span>&nbsp;*</span></label>
            <input class="form-control" type="number" placeholder="Enter SDLC ID"
              id="requirementid" formControlName="arequirementid"  name="arequirementid"/>
              <span class="errormessage"
              *ngIf="addForm.get('arequirementid').invalid && addForm.get('arequirementid').touched ">
              {{getErrorMessage(addForm,validation_message,'arequirementid')}}
            </span>
            </div>
        </div>
        </div>
  

        <div class="formgrid grid">
            <div class="field col-12">
              <div class="form-group">
                <label for="afeature" class="required-label"><b>Function Feature</b> <span> *</span>
                  <span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 500 chars)</span></label>
                <textarea class="form-control" type="text" placeholder="Enter Feature Name" pInputTextarea [autoResize]="true" 
                id="afeature" formControlName="afeature"  name="afeature" rows="2"></textarea>
              <span class="errormessage"
                *ngIf="addForm.get('afeature').invalid && addForm.get('afeature').touched ">
                {{getErrorMessage(addForm ,validation_message,'afeature')}}
              </span>
            </div>
          </div>
          </div>
    
          <div class="formgrid grid">
            <div class="field col-12">
              <div class="form-group">
                <label for="atowhom" class="required-label"><b>To Whom</b> <span> *</span>
                  <span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 100 chars)</span></label>
                  <input class="form-control" type="test" placeholder="Enter To Whom"
                  id="atowhom" formControlName="atowhom"  name="atowhom"/>
              <span class="errormessage"
                *ngIf="addForm.get('atowhom').invalid && addForm.get('atowhom').touched ">
                {{getErrorMessage(addForm ,validation_message,'atowhom')}}
              </span>
            </div>
          </div>
          </div>
    
          <div class="formgrid grid">
            <div class="field col-12">
              <div class="form-group">
                <label for="aadvantages" class="required-label"><b>Advantages</b> <span> *</span>
                  <span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 1500 chars)</span></label>
                <textarea class="form-control" type="text" placeholder="Enter the Advantages" pInputTextarea [autoResize]="true" 
                id="aadvantages" formControlName="aadvantages"  name="aadvantages" rows="2"></textarea>
              <span class="errormessage"
                *ngIf="addForm.get('aadvantages').invalid && addForm.get('aadvantages').touched ">
                {{getErrorMessage(addForm ,validation_message,'aadvantages')}}
              </span>
            </div>
          </div>
          </div>
    
          <div class="formgrid grid">
            <div class="field col-12">
              <div class="form-group">
                <label for="afunctionality" class="required-label"><b>Functionality Description</b> <span> *</span>
                  <span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 5000 chars)</span></label>
                <textarea class="form-control" type="text" placeholder="Enter the Functionality Description"
                pInputTextarea [autoResize]="true" 
                id="afunctionality" formControlName="afunctionality"  name="afunctionality" rows="2"></textarea>
              <span class="errormessage"
                *ngIf="addForm.get('afunctionality').invalid && addForm.get('afunctionality').touched ">
                {{getErrorMessage(addForm ,validation_message,'afunctionality')}}
              </span>
            </div>
          </div>
          </div>
  
    </form>
  
    <div class="custom-dialog-footer">
      <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button>
      <p-button class="m-1" *ngIf="isAdd" label="{{saveTitle}}" styleClass="customesave" (click)="add()"></p-button>
    </div>
  
  </div>
  
